import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {List} from "immutable";
import connect from "react-redux/es/connect/connect";
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import numeral from "numeral";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import {cleanQuotes, getQuotes} from "../../../actions/quotes";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class CustomerQuotes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quoteFilters: ''
        };
    }
    componentDidMount() {
        this.props.getQuotes({
            filters: { customer: this.props.customerId },
            projection: 'quote_code document_date customer statistics.subtotal statistics.vat statistics.total status',
            populateRefs: [{
                field: 'customer',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'quotes',
            deleteVirtuals: true
        });
    }

    render() {
        let tableData = this.props.quotes;

        // Filters Zone
        let totalQuotes = 0;
        this.props.quotes.forEach(order => totalQuotes = totalQuotes + order.getIn(['statistics', 'total']));
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label ">{ numeral(totalQuotes).format() }</span>
                    <span>Total presupuestado</span>
                </div>
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.quotes.size || 0 }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ quoteFilters: '' }) }><strong>Presupuestos</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.quotes.count(quote => quote.get('status') === 'accepted') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'accepted' }) }>Aceptados</span>
                </div>
                <div className="col-auto">
                    <span className="label label-warning">{ this.props.quotes.count(quote => quote.get('status') === 'pending') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'pending' }) }>Pendientes</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.quotes.count(quote => quote.get('status') === 'rejected') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'rejected' }) }>Rechazados</span>
                </div>
                { this.props.status === 'active'
                    ? <div className="col-auto ml-auto">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.props.history.push('/ventas/presupuestos/nuevo', { customerId: this.props.customerId }) }
                        >
                            <Icon icon="insert"/>Presupuesto
                        </button>
                    </div>
                    : null
                }
            </div>
        );
        switch (this.state.quoteFilters) {
            case 'accepted':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ numeral(totalQuotes).format() }</span>
                            <span>Total presupuestado</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.quotes.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: '' }) }>Presupuestos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary"><strong>{ this.props.quotes.count(quote => quote.get('status') === 'accepted') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'accepted' }) }><strong>Aceptados</strong></span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">{ this.props.quotes.count(quote => quote.get('status') === 'pending') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'pending' }) }>Pendientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.quotes.count(quote => quote.get('status') === 'rejected') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'rejected' }) }>Rechazados</span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/ventas/presupuestos/nuevo', { customerId: this.props.customerId }) }
                                >
                                    <Icon icon="insert"/>Presupuesto
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.quotes.filter(quote => quote.get('status') === 'accepted');
                break;
            case 'pending':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ numeral(totalQuotes).format() }</span>
                            <span>Total presupuestado</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.quotes.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: '' }) }>Presupuestos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.quotes.count(quote => quote.get('status') === 'accepted') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'accepted' }) }>Aceptados</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning"><strong>{ this.props.quotes.count(quote => quote.get('status') === 'pending') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'pending' }) }><strong>Pendientes</strong></span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.quotes.count(quote => quote.get('status') === 'rejected') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'rejected' }) }>Rechazados</span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/ventas/presupuestos/nuevo', { customerId: this.props.customerId }) }
                                >
                                    <Icon icon="insert"/>Presupuesto
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.quotes.filter(quote => quote.get('status') === 'pending');
                break;
            case 'rejected':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ numeral(totalQuotes).format() }</span>
                            <span>Total presupuestado</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.quotes.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: '' }) }>Presupuestos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.quotes.count(quote => quote.get('status') === 'accepted') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'accepted' }) }>Aceptados</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">{ this.props.quotes.count(quote => quote.get('status') === 'pending') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'pending' }) }>Pendientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger"><strong>{ this.props.quotes.count(quote => quote.get('status') === 'rejected') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ quoteFilters: 'rejected' }) }><strong>Rechazados</strong></span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/ventas/presupuestos/nuevo', { customerId: this.props.customerId }) }
                                >
                                    <Icon icon="insert"/>Presupuesto
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.quotes.filter(quote => quote.get('status') === 'rejected');
                break;
            default:
                break;
        }

        // Quotes Table
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            quote_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'quote_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/presupuestos/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            customer: {
                title: "Cliente",
                columnType: 'text',
                dataField: 'customer',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'pending':
                            data.badgeColor = 'warning';
                            data.value = 'Pendiente';
                            break;
                        case 'accepted':
                            data.badgeColor = 'primary';
                            data.value = 'Aceptado';
                            break;
                        case 'rejected':
                            data.badgeColor = 'danger';
                            data.value = 'Rechazado';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/presupuestos/' + value)} />
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div className="panel-body">
                { statsZone }
                <div className="row">
                    <div className="col">
                        <div className="ibox">
                            <div className="ibox-content">
                                <VirtualizedTable
                                    tableSettings={tableSettings}
                                    tableColumns={tableColumns}
                                    tableData={tableData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {

    // Reducers
    const quotesReducer = state.quotes;

    // Quotes
    let quotes = quotesReducer.get('payload') || List([]);

    if (!(quotes instanceof List)) {
        quotes = List([])
    }

    return {
        quotes
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getQuotes: (query) => dispatch(getQuotes(query)),
        cleanQuotes: () => dispatch(cleanQuotes())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerQuotes);



// WEBPACK FOOTER //
// ./src/containers/sales/customers/CustomerQuotes.js